var chunkToChildrenMap = {
	"src_bootstrap_tsx-src_assets_images_aircall-workspace_png-src_assets_images_availabilities_do-d5d057": [
		"Login"
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };